import { useEffect, useRef } from 'react';
import { initValidate } from '../helpers/validate';

export function ValidateFormCustom ({ children }: any) {
  const parent = useRef(null)

  useEffect(() => {
    if (!parent.current) return
    const forms = parent.current.querySelectorAll('form')
    
    if (forms.length) {
      forms.forEach((form: any) => {
        if (form) {
          const validate = initValidate(form)
          if (!validate) return
          validate.onSuccess((event) => {
            form.submit(event)
          })
        }
      })
    }
  }, [parent])
  
  return (
    <div ref={parent} dangerouslySetInnerHTML={{ __html: children.innerHTML }}></div>
  )
}
